import gql from 'graphql-tag';

export default gql`
	query ContainersQuery(
		$userId: String!
		$principalId: String!
		$siteId: String!
		$sessionId: String
		$maxNumberOfResults: Int!
	) @custom {
		Containers(
			principalId: $principalId
			userId: $userId
			siteId: $siteId
			sessionId: $sessionId
			maxNumberOfResults: $maxNumberOfResults
		) {
			collaborationGraphEntities {
				id
				containerType
				entityType
				containerDetails {
					id
					key
					name
					url
					iconUrl
				}
			}
		}
	}
`;
